<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { type Ref, computed, inject } from 'vue'
import { IconFont } from '@mp/component'
import { useIsSp, usePermissions } from '@mp/hooks'
import { filterPermissionRouter } from '@mp/utils'
import type { AppRouteRecordRaw } from '@mp/types/router'

const { isNotSp } = useIsSp()
const { permissions } = usePermissions()

const router = useRouter()
const route = useRoute()

const curRoutes = inject<Ref<AppRouteRecordRaw[]>>('currentRoutes', [] as unknown as Ref<AppRouteRecordRaw[]>)
const filterRoutes = computed(() => isNotSp ? filterPermissionRouter(curRoutes.value, permissions.value || []).filter(item => item.name !== 'AccountBank' && item.name !== 'StatementCapitalFlow') : filterPermissionRouter(curRoutes.value, permissions.value || []))

const activeIndex = computed(() => route.name as string)
function handleMenuClick(item: AppRouteRecordRaw) {
  if (item?.meta?.link) {
    let url = item.meta?.link as string

    // ?判断是否是要到老B去
    const istoOldB = url.includes('/login/forward')
    if (istoOldB) {
      const newToken = sessionStorage.getItem('token') || ''
      const newUrl = url.replace(/token=([^&]*)/, `token=${newToken}`)
      url = newUrl
    }

    window.open(url as string)
    return
  }

  router.push({ name: item.name })
}
</script>

<template>
  <el-menu
    :default-active="activeIndex"
    :router="false"
    :style="{
      '--el-menu-bg-color': 'transparent',
      '--el-menu-border-color': 'transparent',
      '--el-menu-hover-text-color': 'var(--el-color-primary)',
      '--el-menu-text-color': 'var(--n-400)',
      '--el-menu-hover-bg-color': '#E4EAF2',
      '--el-menu-item-height': '48px',
      '--el-menu-sub-item-height': '44px',
    }"
  >
    <template v-for="item in filterRoutes" :key="item.path">
      <el-menu-item v-if="item.meta?.isTopLevel" v-track :index="item.name" @click="handleMenuClick(item)">
        <IconFont v-if="item.meta?.icon" :type="item.meta?.icon" class="text-base leading-none mr-1" /> {{ item.meta?.title }}
      </el-menu-item>

      <el-sub-menu v-else :index="item.path">
        <template #title>
          <IconFont v-if="item.meta?.icon" :type="item.meta?.icon" class="text-base leading-none mr-1" /> {{ item.meta?.title }}
        </template>
        <template v-for="child in item.children">
          <el-menu-item
            v-if="!child.meta?.hidden && (!isNotSp || child.name !== 'TransactionTransfer')"
            :key="`${item.path}-${child.path}`"
            v-track
            :index="child.name"
            @click="handleMenuClick(child)"
          >
            {{ child.meta?.title }}
          </el-menu-item>
        </template>
      </el-sub-menu>
    </template>
  </el-menu>
</template>
